import React, { useState, useRef, useEffect } from "react"
import { useDispatch } from "react-redux";

import { BPComparison, Common } from "../../../helper"
import { setBPComparisonSelect } from "../../../store/pupilProgressSlice";

import "../../../assets/stlyes/BigPicture/BigPicture.scss";

import comparisonPowerIcon from "../../../assets/images/ComparisonPowerIcon.svg"
import comparisonPowerIconWhite from "../../../assets/images/ComparisonPowerButtonWhite.svg"
import comparisonGenderArrow from "../../../assets/images/ComparisonGenderArrow.svg"
import comparisonEthnicity from "../../../assets/images/comparisonEthnicity.svg"
import comparisonYear from "../../../assets/images/ComparisonYear.svg"
import comparisonPP from "../../../assets/images/ComparisonPP.svg"
import comparisonEAL from "../../../assets/images/ComparisonEAL.svg"
import comparisonSEND from "../../../assets/images/ComparisonSEND.svg"
import comparisonGLD from "../../../assets/images/ComparisonGLD.svg"

const Comparison = (props) => {
  const { isGLD } = props;
  const [angle, setAngle] = useState(0);
  const [startAngle, setStartAngle] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const knobRef = useRef(null);
  const dispatch = useDispatch();

  const maxAngle = isGLD ? 145 : 125;
  const minAngle = 0;
  const snapAngles = isGLD ? [0, 25, 45, 65, 85, 105, 125, 145] : [0, 25, 45, 65, 85, 105, 125];

  // Selected Angle
  const calculateComparisionAngle = (clientX, clientY) => {
    if (knobRef.current) {
      const knobRect = knobRef.current.getBoundingClientRect();
      const centerX = knobRect.left + knobRect.width / 2;
      const centerY = knobRect.top + knobRect.height / 2;
      const angle = Math.atan2(clientY - centerY, clientX - centerX);
      let degrees = (angle * 180) / Math.PI;
      degrees = degrees >= 0 ? degrees : degrees + 360;
      return degrees;
    }
    return 0;
  };

  // To move regulator down
  const comparisionMouseDown = (event) => {
    event.preventDefault();
    const newAngle = calculateComparisionAngle(event.clientX, event.clientY);
    setStartAngle(newAngle);
    setIsDragging(true);
  };

  const comparisionMouseMove = (event) => {
    event.preventDefault();
    if (isDragging) {
      const newAngle = calculateComparisionAngle(event.clientX, event.clientY);
      let diff = newAngle - startAngle;
      let rotatedAngle = angle + diff;

      if (rotatedAngle > maxAngle) {
        rotatedAngle = maxAngle;
      } else if (rotatedAngle < minAngle) {
        rotatedAngle = minAngle;
      } else {
        setAngle(rotatedAngle);
      }
      setStartAngle(newAngle);
    }
  };

  const comparisionMouseUp = () => {
    if (isDragging) {
      setIsDragging(false);
    }
  };

  // Selecting nearest Angle
  const snapToClosestAngle = (currentAngle) => {
    let closestAngle = snapAngles[0];
    let minDiff = Math.abs(currentAngle - closestAngle);

    snapAngles.forEach((snapAngle) => {
      const diff = Math.abs(currentAngle - snapAngle);
      if (diff < minDiff) {
        minDiff = diff;
        closestAngle = snapAngle;
      }
    });
    return closestAngle;
  };

  // Setting selected Comparision to redux
  const comparisionSelect = () => {
    switch (angle) {
    case 0: dispatch(setBPComparisonSelect(BPComparison.None))
      break;
    case 25: dispatch(setBPComparisonSelect(BPComparison.Gender))
      break;
    case 45: dispatch(setBPComparisonSelect(BPComparison.Ethnicity))
      break;
    case 65: dispatch(setBPComparisonSelect(Common.Year.toUpperCase()))
      break;
    case 85: dispatch(setBPComparisonSelect(BPComparison.PP))
      break;
    case 105: dispatch(setBPComparisonSelect(BPComparison.EAL))
      break;
    case 125: dispatch(setBPComparisonSelect(BPComparison.SEND))
      break;
    case 145: dispatch(setBPComparisonSelect(BPComparison.GLD))
      break;
    default:
      break;
    }
  }

  useEffect(() => {
    if (!isDragging) {
      const closestAngle = snapToClosestAngle(angle);
      setAngle(closestAngle);
    }
    comparisionSelect();
  }, [angle, isDragging]);

  // Selecting by dragging
  const comparisionTouchStart = (event) => {
    event.preventDefault();
    const touch = event.touches[0];
    const newAngle = calculateComparisionAngle(touch.clientX, touch.clientY);
    setStartAngle(newAngle);
    setIsDragging(true);
  };

  const comparisionTouchMove = (event) => {
    event.preventDefault();
    if (isDragging) {
      const touch = event.touches[0];
      const newAngle = calculateComparisionAngle(touch.clientX, touch.clientY);
      let diff = newAngle - startAngle;
      let rotatedAngle = angle + diff;

      if (rotatedAngle > maxAngle) {
        rotatedAngle = maxAngle;
      } else if (rotatedAngle < minAngle) {
        rotatedAngle = minAngle;
      } else {
        setAngle(rotatedAngle);
      }
      setStartAngle(newAngle);
    }
  };

  const comparisionTouchEnd = () => {
    if (isDragging) {
      setIsDragging(false);
    }
  };

  // Moving regulator on clicking on name
  const comparisionChangeAngle = () => {
    let maxAngle = isGLD ? 145 : 125;
    switch (angle) {
    case 0: setAngle(25);
      break;
    case maxAngle: setAngle(0);
      break;
    default: setAngle(angle + 20);
      break;
    }
  }
  return (
    <div className="comparisonMain">
      <span className="comparisonHeading">{BPComparison.Comparison}</span>
      <div className="comparisonRotateMain">
        <div className="comparisonRotate">
          <span className="comparisonPowerButton" onClick={() => setAngle(0)} onKeyDown={(e) => { e.key === "Enter" && setAngle(0) }} tabIndex={0} role="button">
            <img src={angle !== 0 ? comparisonPowerIconWhite : comparisonPowerIcon} alt="" />
          </span>
          <div className="comparisonButton comparisonButtonOne" onClick={() => setAngle(25)} style={{ backgroundColor: angle !== 25 ? "" : "#6D47FF" }} onKeyDown={(e) => { e.key === "Enter" && setAngle(25) }} tabIndex={0} role="button"></div>
          <div className="comparisonButton comparisonButtonTwo" onClick={() => setAngle(45)} style={{ backgroundColor: angle !== 45 ? "" : "#6D47FF" }} onKeyDown={(e) => { e.key === "Enter" && setAngle(45) }} tabIndex={0} role="button"></div>
          <div className="comparisonButton comparisonButtonThree" onClick={() => setAngle(65)} style={{ backgroundColor: angle !== 65 ? "" : "#6D47FF" }} onKeyDown={(e) => { e.key === "Enter" && setAngle(65) }} tabIndex={0} role="button"></div>
          <div className="comparisonButton comparisonButtonFour" onClick={() => setAngle(85)} style={{ backgroundColor: angle !== 85 ? "" : "#6D47FF" }} onKeyDown={(e) => { e.key === "Enter" && setAngle(85) }} tabIndex={0} role="button"></div>
          <div className="comparisonButton comparisonButtonFive" onClick={() => setAngle(105)} style={{ backgroundColor: angle !== 105 ? "" : "#6D47FF" }} onKeyDown={(e) => { e.key === "Enter" && setAngle(105) }} tabIndex={0} role="button"></div>
          <div className="comparisonButton comparisonButtonSix" onClick={() => setAngle(125)} style={{ backgroundColor: angle !== 125 ? "" : "#6D47FF" }} onKeyDown={(e) => { e.key === "Enter" && setAngle(125) }} tabIndex={0} role="button"></div>
          <div className="comparisonButton comparisonButtonSeven" onClick={() => setAngle(145)} style={{ backgroundColor: isGLD ? (angle !== 145 ? "" : "#6D47FF") : "#E2DAFF", border: isGLD ? "" : "none" }} onKeyDown={(e) => { e.key === "Enter" && setAngle(145) }} tabIndex={0} role="button"></div>
          <img src={comparisonGenderArrow} alt="" className="comparisonGenderArrowImage" />
          <div className="comparisonGenderArrow comparisonArrowText" onClick={() => setAngle(25)} onKeyDown={(e) => { e.key === "Enter" && setAngle(25) }} tabIndex={0} role="button">{BPComparison.Gender}</div>
          <img src={comparisonEthnicity} alt="" className="comparisonEthnicityArrowImage" />
          <div className="comparisonEthnicityArrow comparisonArrowText" onClick={() => setAngle(45)} onKeyDown={(e) => { e.key === "Enter" && setAngle(45) }} tabIndex={0} role="button">{BPComparison.Ethnicity}</div>
          <img src={comparisonYear} alt="" className="comparisonYearArrowImage" />
          <div className="comparisonYearArrow comparisonArrowText" onClick={() => setAngle(65)} onKeyDown={(e) => { e.key === "Enter" && setAngle(65) }} tabIndex={0} role="button">{Common.Year.toUpperCase()}</div>
          <img src={comparisonPP} alt="" className="comparisonPPArrowImage" />
          <div className="comparisonPPArrow comparisonArrowText" onClick={() => setAngle(85)} onKeyDown={(e) => { e.key === "Enter" && setAngle(85) }} tabIndex={0} role="button">{BPComparison.PP}</div>
          <img src={comparisonEAL} alt="" className="comparisonEALArrowImage" />
          <div className="comparisonEALArrow comparisonArrowText" onClick={() => setAngle(105)} onKeyDown={(e) => { e.key === "Enter" && setAngle(105) }} tabIndex={0} role="button">{BPComparison.EAL}</div>
          <img src={comparisonSEND} alt="" className="comparisonSENDArrowImage" />
          <div className="comparisonSENDArrow comparisonArrowText" onClick={() => setAngle(125)} onKeyDown={(e) => { e.key === "Enter" && setAngle(125) }} tabIndex={0} role="button">{BPComparison.SEND}</div>
          {isGLD && <React.Fragment><img src={comparisonGLD} alt="" className="comparisonGLDArrowImage" />
            <div className="comparisonGLDArrow comparisonArrowText" onClick={() => setAngle(145)} onKeyDown={(e) => { e.key === "Enter" && setAngle(145) }} tabIndex={0} role="button">{BPComparison.GLD}</div></React.Fragment>}
        </div>
        <div className="comparisonRotateSecond" onClick={comparisionChangeAngle} onKeyDown={(e) => { e.key === "Enter" && comparisionChangeAngle() }} tabIndex={0} role="button" ref={knobRef} onMouseDown={comparisionMouseDown} onMouseMove={comparisionMouseMove} onMouseUp={comparisionMouseUp} onMouseLeave={comparisionMouseUp} onTouchStart={comparisionTouchStart} onTouchMove={comparisionTouchMove} onTouchEnd={comparisionTouchEnd}>
          <span className="comparisonNeedle" style={{ transform: `translateX(50%) rotate(${angle}deg)` }}></span>
        </div>
      </div>
    </div>
  )
}

export { Comparison }
